import { Injectable } from '@angular/core';
import { FC_MotherMemoria } from '../funcionesCompatibilidad/FC_MotherMemoria';
import { Incompatibilities } from '../Incompatibilities';
import { Memoria } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FA_Memoria extends FuncionesArmadoBase<Memoria> {
  constructor(private fc_motherMemoria: FC_MotherMemoria) {
    super();
  }
  funciones = {
    // TODO: si la memoria es incompatible con la mother debería tener solo una incompatibilidad e ignorar la de cantidad
    cantidad: (dataArmado: DataArmado, memoria: Memoria): Incompatibilities[] => {
      let tipoMem = memoria.$caracteristicas.tipo;
      let cantidadMaxima = 4;
      let mother = dataArmado.mother[0];
      let cantidadSeleccionada = dataArmado.memorias.reduce(
        (cantidad, mem) => cantidad + mem.$caracteristicas.slot,
        0,
      );

      if (mother) {
        cantidadMaxima = mother.$caracteristicas[tipoMem] ?? cantidadMaxima;
      }

      if (cantidadSeleccionada > cantidadMaxima)
        return [
          {
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: 'Excede la cantidad máxima de memorias',
          },
        ];

      if (cantidadSeleccionada + memoria.$caracteristicas.slot > cantidadMaxima) {
        //REVISO SI LA MEMORIA ANALIZADA ESTA EN EL ARMADO
        if (dataArmado.memorias.find((mem) => mem.id_producto == memoria.id_producto)) {
          //SÓLO CARGALE LA INCOMPATIBILIDAD SI LA CANTIDAD DEL ARMADO == CANT MAX ó si le agregas una memoria más de las dobles
          if (
            cantidadSeleccionada == cantidadMaxima ||
            cantidadSeleccionada + memoria.$caracteristicas.slot > cantidadMaxima
          ) {
            return [
              {
                tipo: IncompatibilitiesType.DEFAULT_STOCK,
                incompatibility: '',
              },
            ];
          }

          //SINO DEVOLVE NULL XQ TODAVIA HAY LUGAR EN EL ARMADO
          return null;
        }
        //SI NO ESTA, CARGALE LA INCOMPATIBILIDAD
        return [
          {
            tipo: IncompatibilitiesType.CANTIDAD,
            incompatibility:
              mother ?
                'La mother no soporta otra memoria'
              : 'Excede la cantidad máxima de memorias',
          },
        ];
      }
      return null;
    },
    mismotTipo: (dataArmado: DataArmado, memoria: Memoria): Incompatibilities[] => {
      const memoriaEnArmado = dataArmado.memorias[0];
      if (!memoriaEnArmado) return null;
      return memoriaEnArmado.$caracteristicas.tipo != memoria.$caracteristicas.tipo ?
          [
            {
              tipo: IncompatibilitiesType.ARMADO,
              incompatibility: 'Las memorias tienen que ser del mismo tipo',
            },
          ]
        : null;
    },
    mother: (dataArmado: DataArmado, memoria: Memoria) => {
      const motherEnArmado = dataArmado.mother[0];
      if (!motherEnArmado) return [];
      return this.fc_motherMemoria.ejecutar(motherEnArmado, memoria);
    },
  };
}
